// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"171bfb33","628":"3261519f"}[chunkId] + ".chunk.js";
};